import React from 'react';
import documentsIcon from '../../../assets/img/matched/documents_icon.png';

import { Card, Button, Grid, Translation } from '../../common';
import DownloadIcon from '@material-ui/icons/SaveAlt';

export const HEADER = 'UPLOAD_HEADER';
export const DESCRIPTION = 'UPLOAD_DESCRIPTION';
export const BUTTON = 'UPLOAD_BUTTON';
export const EXTENSIONS = 'UPLOAD_EXTENSIONS';

export default ({ styles, onButtonClick }) => (
  <Card className={styles['upload-file__wrapper']}>
    <Grid
      container
      justify="space-between"
      className={styles['upload-file__content']}
    >
      <Grid
        item
        container
        justify="space-between"
        direction="column"
        className={styles['upload-file__text']}
        md={5}
      >
        <h1 className={styles['upload-file__text-header']}>
          <Translation>{HEADER}</Translation>
        </h1>
        <div className={styles['upload-file__text-content']}>
          <Translation>{DESCRIPTION}</Translation>
        </div>
      </Grid>
      <Grid item md={2} container justify="center">
        <img
          src={documentsIcon}
          className={styles['upload-file__image']}
          alt="upload-icon"
        />
      </Grid>
      <Grid
        item
        md={5}
        container
        alignItems="center"
        className={styles['upload-file__dropzone-wrapper']}
      >
        <div className={styles['upload-file__dropzone-content']}>
          <Button
            id="page.postbox.component.upload-file.upload-file-button"
            className={styles['upload-file__dropzone-button']}
            onClick={onButtonClick}
          >
            <DownloadIcon
              className={styles['upload-file__dropzone-button-icon']}
            />
            <span>
              <Translation>{BUTTON}</Translation>
            </span>
          </Button>
          <div className={styles['upload-file__dropzone-formats']}>
            <Translation>{EXTENSIONS}</Translation>
          </div>
        </div>
      </Grid>
    </Grid>
  </Card>
);
